//
// Copyright 2020 DXOS.org
//
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_dxos_keys } from "./keys_pb.js";
/**
 * Describes the file dxos/iframe.proto.
 */
export const file_dxos_iframe = /*@__PURE__*/ fileDesc("ChFkeG9zL2lmcmFtZS5wcm90bxILZHhvcy5pZnJhbWUi7gEKEUFwcENvbnRleHRSZXF1ZXN0Ei8KB2Rpc3BsYXkYASABKA4yGS5keG9zLmlmcmFtZS5TaGVsbERpc3BsYXlIAIgBARIsCglzcGFjZV9rZXkYAiABKAsyFC5keG9zLmtleXMuUHVibGljS2V5SAGIAQESFQoIc3BhY2VfaWQYBSABKAlIAogBARITCgZ0YXJnZXQYAyABKAlIA4gBARISCgVyZXNldBgEIAEoCEgEiAEBQgoKCF9kaXNwbGF5QgwKCl9zcGFjZV9rZXlCCwoJX3NwYWNlX2lkQgkKB190YXJnZXRCCAoGX3Jlc2V0IusBCg1MYXlvdXRSZXF1ZXN0EigKBmxheW91dBgBIAEoDjIYLmR4b3MuaWZyYW1lLlNoZWxsTGF5b3V0EhwKD2ludml0YXRpb25fY29kZRgCIAEoCUgAiAEBEiwKCXNwYWNlX2tleRgDIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXlIAYgBARIVCghzcGFjZV9pZBgFIAEoCUgCiAEBEhMKBnRhcmdldBgEIAEoCUgDiAEBQhIKEF9pbnZpdGF0aW9uX2NvZGVCDAoKX3NwYWNlX2tleUILCglfc3BhY2VfaWRCCQoHX3RhcmdldCJvChRJbnZpdGF0aW9uVXJsUmVxdWVzdBIWCg5pbnZpdGF0aW9uX3VybBgBIAEoCRIfChdkZXZpY2VfaW52aXRhdGlvbl9wYXJhbRgCIAEoCRIeChZzcGFjZV9pbnZpdGF0aW9uX3BhcmFtGAMgASgJKigKDFNoZWxsRGlzcGxheRIICgROT05FEAASDgoKRlVMTFNDUkVFThABKt4BCgtTaGVsbExheW91dBILCgdERUZBVUxUEAASFwoTSU5JVElBTElaRV9JREVOVElUWRABEicKI0lOSVRJQUxJWkVfSURFTlRJVFlfRlJPTV9JTlZJVEFUSU9OEAISJQohSU5JVElBTElaRV9JREVOVElUWV9GUk9NX1JFQ09WRVJZEAkSDAoISURFTlRJVFkQAxISCg5TSEFSRV9JREVOVElUWRAEEhAKDEVESVRfUFJPRklMRRAFEgkKBVNQQUNFEAYSDgoKSk9JTl9TUEFDRRAHEgoKBlNUQVRVUxAIMlIKCkFwcFNlcnZpY2USRAoKU2V0Q29udGV4dBIeLmR4b3MuaWZyYW1lLkFwcENvbnRleHRSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5Mp4BCgxTaGVsbFNlcnZpY2USPwoJU2V0TGF5b3V0EhouZHhvcy5pZnJhbWUuTGF5b3V0UmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRJNChBTZXRJbnZpdGF0aW9uVXJsEiEuZHhvcy5pZnJhbWUuSW52aXRhdGlvblVybFJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHliBnByb3RvMw", [file_google_protobuf_empty, file_dxos_keys]);
/**
 * Describes the message dxos.iframe.AppContextRequest.
 * Use `create(AppContextRequestSchema)` to create a new message.
 */
export const AppContextRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_iframe, 0);
/**
 * Describes the message dxos.iframe.LayoutRequest.
 * Use `create(LayoutRequestSchema)` to create a new message.
 */
export const LayoutRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_iframe, 1);
/**
 * Describes the message dxos.iframe.InvitationUrlRequest.
 * Use `create(InvitationUrlRequestSchema)` to create a new message.
 */
export const InvitationUrlRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_iframe, 2);
/**
 * @generated from enum dxos.iframe.ShellDisplay
 */
export var ShellDisplay;
(function (ShellDisplay) {
    /**
     * @generated from enum value: NONE = 0;
     */
    ShellDisplay[ShellDisplay["NONE"] = 0] = "NONE";
    /**
     * @generated from enum value: FULLSCREEN = 1;
     */
    ShellDisplay[ShellDisplay["FULLSCREEN"] = 1] = "FULLSCREEN";
})(ShellDisplay || (ShellDisplay = {}));
/**
 * Describes the enum dxos.iframe.ShellDisplay.
 */
export const ShellDisplaySchema = /*@__PURE__*/ enumDesc(file_dxos_iframe, 0);
/**
 * @generated from enum dxos.iframe.ShellLayout
 */
export var ShellLayout;
(function (ShellLayout) {
    /**
     * @generated from enum value: DEFAULT = 0;
     */
    ShellLayout[ShellLayout["DEFAULT"] = 0] = "DEFAULT";
    /**
     * @generated from enum value: INITIALIZE_IDENTITY = 1;
     */
    ShellLayout[ShellLayout["INITIALIZE_IDENTITY"] = 1] = "INITIALIZE_IDENTITY";
    /**
     * @generated from enum value: INITIALIZE_IDENTITY_FROM_INVITATION = 2;
     */
    ShellLayout[ShellLayout["INITIALIZE_IDENTITY_FROM_INVITATION"] = 2] = "INITIALIZE_IDENTITY_FROM_INVITATION";
    /**
     * @generated from enum value: INITIALIZE_IDENTITY_FROM_RECOVERY = 9;
     */
    ShellLayout[ShellLayout["INITIALIZE_IDENTITY_FROM_RECOVERY"] = 9] = "INITIALIZE_IDENTITY_FROM_RECOVERY";
    /**
     * @generated from enum value: IDENTITY = 3;
     */
    ShellLayout[ShellLayout["IDENTITY"] = 3] = "IDENTITY";
    /**
     * @generated from enum value: SHARE_IDENTITY = 4;
     */
    ShellLayout[ShellLayout["SHARE_IDENTITY"] = 4] = "SHARE_IDENTITY";
    /**
     * @generated from enum value: EDIT_PROFILE = 5;
     */
    ShellLayout[ShellLayout["EDIT_PROFILE"] = 5] = "EDIT_PROFILE";
    /**
     * @generated from enum value: SPACE = 6;
     */
    ShellLayout[ShellLayout["SPACE"] = 6] = "SPACE";
    /**
     * @generated from enum value: JOIN_SPACE = 7;
     */
    ShellLayout[ShellLayout["JOIN_SPACE"] = 7] = "JOIN_SPACE";
    /**
     * @generated from enum value: STATUS = 8;
     */
    ShellLayout[ShellLayout["STATUS"] = 8] = "STATUS";
})(ShellLayout || (ShellLayout = {}));
/**
 * Describes the enum dxos.iframe.ShellLayout.
 */
export const ShellLayoutSchema = /*@__PURE__*/ enumDesc(file_dxos_iframe, 1);
/**
 * / App RPCs for the shell.
 *
 * @generated from service dxos.iframe.AppService
 */
export const AppService = /*@__PURE__*/ serviceDesc(file_dxos_iframe, 0);
/**
 * / Shell UI RPCs.
 *
 * @generated from service dxos.iframe.ShellService
 */
export const ShellService = /*@__PURE__*/ serviceDesc(file_dxos_iframe, 1);
//# sourceMappingURL=iframe_pb.js.map